import { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { authContext } from "./contexts/AuthProvider";
import { dataContext } from "./contexts/DataProvider";
import { errorContext } from "./contexts/ErrorProvider";
import ProcessData from "./utils/ProcessData";
import validate from "./validation/validator";
import { loginSchema } from "./validation/schema";
import { merchantEmployeeLogin } from "./services/authService";
import Loader from "./layout/Loader";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useContext(dataContext);
  const [errors, setErrors] = useContext(errorContext);
  const [isAuth] = useContext(authContext);
  const navigate = useNavigate();

  const login = async () => {
    const validation = validate(data, setErrors, loginSchema());
    if (validation === true) {
      setIsLoading(true);
      const response = await merchantEmployeeLogin(data);
      setIsLoading(false);
      if (response.data.code === 0) {
        if (response.data.message === "Email not registered") {
          setErrors({
            ...errors,
            email: response.data.message,
          });
        }
        if (response.data.message === "Password is incorrect") {
          setErrors({
            ...errors,
            password: response.data.message,
          });
        }
        if (response.data.message === "You are suspended") {
          setErrors({
            ...errors,
            suspened: response.data.message,
          });
          setData({});
        }
      } else if (response.data.code === 1) {
        localStorage.setItem(
          "wow-delivery-kw-merchant-token",
          response.data.data
        );
        window.location.replace(window.location.href);
      }
    }
  };

  useEffect(() => {
    if (isAuth === true) {
      navigate("/dashboard");
    }
    if (isAuth === false) {
      setIsLoading(false);
    }
  }, [isAuth, navigate]);
  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="container">
      <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12">
          <div className="card custom-card my-4">
            <div className="card-body p-5">
              <div className="mb-4 d-flex justify-content-center">
                <Link to={`/`}>
                  <img
                    src="assets/images/brand-logos/desktop-logo.png"
                    alt="logo"
                    className="desktop-logo"
                  />
                  <img
                    src="assets/images/brand-logos/desktop-white.png"
                    alt="logo"
                    className="desktop-white"
                  />
                </Link>
              </div>
              <p className="h5 mb-2 text-center">Sign In</p>
              <p className="text-muted mb-4 text-center">Let's get started</p>
              <div className="row gy-3">
                <div className="col-xl-12 mb-3">
                  {errors?.suspened && (
                    <Alert variant="filled" severity="error">
                      {errors?.suspened}
                    </Alert>
                  )}
                </div>
              </div>
              <div className="row gy-3">
                <div className="col-xl-12">
                  <label
                    htmlFor="signin-username"
                    className="form-label text-default"
                  >
                    User Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="signin-username"
                    placeholder="user name"
                    autoComplete="off"
                    value={data?.email ?? ""}
                    onChange={(e) => {
                      ProcessData(
                        data,
                        setData,
                        e,
                        "string",
                        "email",
                        errors,
                        setErrors
                      );
                    }}
                  />
                  <small className="text-danger">{errors?.email ?? ""}</small>
                </div>
                <div className="col-xl-12 mb-2">
                  <label
                    htmlFor="signin-password"
                    className="form-label text-default d-block"
                  >
                    Password
                    <Link
                      to={`/forgot-password`}
                      className="float-end fw-normal text-primary fw-medium"
                    >
                      Forgot password ?
                    </Link>
                  </label>
                  <div className="position-relative">
                    <input
                      type={showPassword ? `text` : `password`}
                      className="form-control create-password-input"
                      id="signin-password"
                      placeholder="password"
                      autoComplete="off"
                      value={data?.password ?? ""}
                      onChange={(e) => {
                        ProcessData(
                          data,
                          setData,
                          e,
                          "string",
                          "password",
                          errors,
                          setErrors
                        );
                      }}
                    />
                    <span
                      onClick={() => {
                        setShowPassword(!showPassword);
                      }}
                      className="show-password-button text-muted"
                      id="button-addon2"
                    >
                      <i
                        className={
                          showPassword
                            ? `ri-eye-line align-middle`
                            : `ri-eye-off-line align-middle`
                        }
                      ></i>
                    </span>
                  </div>
                  <small className="text-danger">
                    {errors?.password ?? ""}
                  </small>
                </div>
              </div>
              <div className="d-grid mt-3">
                <button onClick={login} className="btn btn-primary">
                  Sign In
                </button>
                {/* <p className="text-muted mt-3 mb-0 text-center">
                  Dont have an account?
                  <a href="sign-up-basic.html" className="text-primary fw-medium">
                    Sign Up
                  </a>
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
